// Documented exception to the "no hardcoded strings" rule: this screen renders
// when configuration is invalid, before React and i18n are loaded, and the
// locale files' own path depends on configuration. Do not move these strings
// into strings.tsx. Details go to the console, never into the page.
const showMessage = (container: HTMLElement, testId: string, text: string) => {
  const message = document.createElement("p");
  message.setAttribute("data-testid", testId);
  message.style.cssText = "font-family:sans-serif;padding:2rem;color:#212529";
  message.textContent = text;
  container.replaceChildren(message);
};

const renderConfigError = (container: HTMLElement, errors: string[]) => {
  console.error("Application configuration is invalid:\n" + errors.join("\n"));
  showMessage(
    container,
    "app-config-error",
    "This application is not configured correctly. Please contact your administrator. / " +
      "لم يتم إعداد هذا التطبيق بشكل صحيح. يرجى التواصل مع مسؤول النظام."
  );
};

/**
 * The configuration is valid but the application code could not be loaded (typically a chunk
 * that a newer deployment deleted while the browser still holds an older index.html).
 * That is not a configuration problem, so the screen must not say it is.
 */
export const renderLoadError = (container: HTMLElement, error: unknown) => {
  console.error("Application failed to load:", error);
  showMessage(
    container,
    "app-load-error",
    "The application failed to load. Please reload the page; if the problem persists, clear your browser cache. / " +
      "فشل تحميل التطبيق. يرجى إعادة تحميل الصفحة، وإذا استمرت المشكلة فامسح ذاكرة التخزين المؤقت للمتصفح."
  );
};

export default renderConfigError;
